var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-table-header__button",on:{"click":_vm.toggle}},[(!_vm.isOpen)?_c('plus',{staticClass:"wizard-section__icon",attrs:{"color":_vm.color}}):_vm._e(),(_vm.isOpen)?_c('minus',{staticClass:"wizard-section__icon",attrs:{"color":_vm.color}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }